import * as fieldset from './fieldset';

export default {
  title: 'Create Supplier Blog Post',
  elements: [
    {
      type: 'createForm',
      config: {
        actions: {
          save: {
            endpoint: 'supplier-blog-posts',
            method: 'POST'
          }
        },
        fieldsets: [fieldset.main]
      }
    }
  ]
};
